<script>

import WAllPerfList from '@/views/performance/group/perfinfo/components/AllPerfList';
import MapAPI from '@/api/topologymap/common';
import { OBJDEFINE } from '@/constants/objdefine';
import { keys, isEmpty } from 'lodash';

export default {
  name: 'WTopologymapAllPerfList',
  extends: WAllPerfList,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      totalPerfData: 0,
      currentPage: 1,
      params: {
        managegroupIds: [],
        objDefineIds: [],
      },
    };
  },
  computed: {
  },
  methods: {
    loadStore() {
      if (this.active) {
        this.params.start = (this.currentPage * this.pageSize) - this.pageSize;
        this.params.limit = this.pageSize;
        this.params.objDefineIds = this.selectedObjDefineIds.length === 0 ? keys(OBJDEFINE) : this.selectedObjDefineIds;
        this.params.mapId = this.$store.getters.getCurrentMapId;
        this.setSearchParams();
        this.isLoading = true;
        MapAPI.getGroupPerformanceInfo(this.params).then((response) => {
          if (response.data.success) {
            if (!isEmpty(response.data.data)) {
              this.totalPerfData = response.data.total;
              this.perfData = response.data.data;
            } else {
              this.totalPerfData = 0;
              this.perfData = [];
            }
          }
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/performance/components/TopologymapAllPerfList.vue